import { Banner, PersonalizedBannerResponse } from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useQuery } from '@tanstack/react-query';

import {
  BACKOFFICE_BANNER_LEGACY_QUERY_KEY,
  BACKOFFICE_BANNER_QUERY_KEY,
  ENDPOINT_BANNER_CG3,
  ENDPOINT_BANNER_LEGACY,
} from '../constant';

export function useBannerListLegacy(options: { enabled?: boolean } = {}) {
  const { access_token } = useAuthStore();
  return useQuery({
    queryKey: [BACKOFFICE_BANNER_LEGACY_QUERY_KEY],
    queryFn: async () => {
      const { data } = await apiInstance(access_token).get<Banner>(
        ENDPOINT_BANNER_LEGACY
      );
      return data;
    },
    enabled: options.enabled ?? true,
  });
}

export function usePersonalizedBanners(
  params: { page: number; size: number },
  options: { enabled?: boolean } = {}
) {
  const { access_token } = useAuthStore();
  const { page, size } = params;
  return useQuery({
    queryKey: [BACKOFFICE_BANNER_QUERY_KEY, page, size],
    queryFn: async () => {
      const { data } = await apiInstance(
        access_token
      ).get<PersonalizedBannerResponse>(ENDPOINT_BANNER_CG3, {
        params: { page, size },
      });
      return data;
    },
    enabled: options.enabled ?? true,
  });
}
